import React, { useEffect, useState } from "react";
// react plugin used to create charts
import { Line } from "react-chartjs-2";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Table,
  Row,
  Col,
  Popover,
  PopoverBody,
  PopoverHeader
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";

import {
  dashboardDailySpendingChart,
} from "variables/charts.js";

import useGlobal from "store";
import TrackingTableRow from "./TrackingTableRow";


const Dashboard = (props) => {

  const [state, actions] = useGlobal(
    state => state,
    actions => actions
  );

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => {
      setTooltipOpen(!tooltipOpen);
      // setTimeout(() => {
      //     setTooltipOpen(false);
      // }, 2000);
  }

  useEffect(() => {
    console.log('user state', state.user);
    if(!state.user) {
      return;
    }
    actions.userActions.getUserBudgets();
    actions.userActions.getUserTracking();
    actions.userActions.getUserTracking('last-month');
  }, [state.user, actions.userActions]);

  const thisMonthTable = state.tracking 
          && state.tracking['this-month']
          && state.tracking['this-month'].sites ? state.tracking['this-month'].sites.map(data => <TrackingTableRow key={data.app_id} {...data} details={state.tracking['this-month'].raw.filter(d => d.business_app_id === data.app_id && d.percent_consumed > 0)}></TrackingTableRow>) : <></>;
  
  const lastMonthTable = state.tracking 
          && state.tracking['last-month']
          && state.tracking['last-month'].sites ? state.tracking['last-month'].sites.map(data => <TrackingTableRow key={data.app_id} {...data} details={state.tracking['last-month'].raw.filter(d => d.business_app_id === data.app_id && d.percent_consumed > 0)}></TrackingTableRow>) : <></>;

  const thisMonthTotal = state.tracking 
          && state.tracking['this-month']
          && state.tracking['this-month'].sites ? state.tracking['this-month'].sites.map(data => data.payment_cap_active ? Math.min(data.payment_cap_amount, data.total_charged) : data.total_charged).reduce((pv, cv) => pv + cv, 0).toFixed(2) : 0;
  
  const lastMonthTotal = state.tracking 
          && state.tracking['last-month']
          && state.tracking['last-month'].sites ? state.tracking['last-month'].sites.map(data => data.total_charged).reduce((pv, cv) => pv + cv, 0).toFixed(2) : 0;
  
  const lastMonthSubscriptions = state.tracking 
          && state.tracking['last-month']
          && state.tracking['last-month'].sites ? state.tracking['last-month'].sites.map(data => data.monthly_subscription_cost).reduce((pv, cv) => pv + cv, 0).toFixed(2) : 0;
  

  const [thisMonthChart, setThisMonthChart] = useState(dashboardDailySpendingChart);
  const [thisMonthChartReference, setThisMonthChartReference] = useState(null);
  useEffect(() => {
    console.log('tracking', state.tracking);
    if(!state.tracking 
      || !state.tracking['this-month'] 
      || !state.tracking['this-month'].daily
      || !thisMonthChartReference) {
      return;
    }
    const labels = state.tracking['this-month'].daily.map(day => day.day_consumed);
    const data = state.tracking['this-month'].daily.map(day => day.total_charged);
    let newChart = dashboardDailySpendingChart(labels, data, '#4BA2AC');
    setThisMonthChart(newChart);
    let thisMonthChart = thisMonthChartReference.chartInstance;
    thisMonthChart.update();
  }, [state.tracking, thisMonthChartReference]);



  const [lastMonthChart, setLastMonthChart] = useState(dashboardDailySpendingChart);
  const [lastMonthChartReference, setLastMonthChartReference] = useState(null);
  useEffect(() => {
    if(!state.tracking 
      || !state.tracking['last-month'] 
      || !state.tracking['last-month'].daily
      || !lastMonthChartReference) {
      return;
    }
    const labels = state.tracking['last-month'].daily.map(day => day.day_consumed);
    const data = state.tracking['last-month'].daily.map(day => day.total_charged);
    let newChart = dashboardDailySpendingChart(labels, data, '#FFC7AD');
    setLastMonthChart(newChart);
    let lastMonthChart = lastMonthChartReference.chartInstance;
    lastMonthChart.update();
  }, [state.tracking, lastMonthChartReference]);

  const refreshData = () => {
    console.log('refresh data');
    actions.userActions.getUserTracking();
  }

  return (
      <>
        
        <PanelHeader
          size="sm"
        />
        <div className="content">
          <Row>
            <Col xs={12} md={6}>
              <Card className="card-chart">
                <CardHeader style={{display:"flex", justifyContent:"space-between"}}>
                  <div>
                    <h5 className="card-category">This Month</h5>
                    <CardTitle tag="h2">${thisMonthTotal}</CardTitle>
                  </div>
                  <div>

                  </div>
                  
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    { thisMonthChart ? 
                      <Line
                        data={thisMonthChart.data}
                        options={thisMonthChart.options}
                        ref = {(reference) => setThisMonthChartReference(reference)}
                    /> : <></> }
                  </div>
                  <Table responsive>
                    <tbody>{thisMonthTable}</tbody>
                  </Table>
                </CardBody>
                <CardFooter>
                  <div className="stats">
                    <p className="card-category text-right" onClick={()=>refreshData()}><i className="fa fa-refresh"/></p>
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={6}>
              <Card className="card-chart">
                <CardHeader style={{display:"flex", justifyContent:"space-between"}}>
                  <div>
                    <h5 className="card-category">Last Month</h5>
                    <CardTitle tag="h2">${lastMonthTotal}</CardTitle>
                  </div>
                  <Popover placement="top" trigger="hover" isOpen={tooltipOpen} target={'youSavedBox'} toggle={toggle}>
                      <PopoverHeader className="text-dark">How savings is calculated</PopoverHeader>
                      <PopoverBody>We took the normal monthly subscription rates of each publication you read this month</PopoverBody>
                    </Popover>
                  <div id={'youSavedBox'}>
                    <p className="card-category text-right">You saved</p>
                    <CardTitle tag="h4">${(lastMonthSubscriptions - lastMonthTotal).toFixed(2)}</CardTitle>
                  </div>
                      
                     
                  
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                  { lastMonthChart ? 
                      <Line
                        data={lastMonthChart.data}
                        options={lastMonthChart.options}
                        ref = {(reference) => setLastMonthChartReference(reference)}
                    /> : <></> }
                  </div>
                  <Table responsive>
                    <tbody>{lastMonthTable}</tbody>
                  </Table>
                </CardBody>
                <CardFooter>
                  <div className="stats">
                    
                  </div>
                </CardFooter>
              </Card>
            </Col>
            
          </Row>
          
        </div>
      </>
    );
}

export default Dashboard;
